// 页面跳转
export const changeToPath = (router, path) => {
    if (router) {
        router.push(path);
    } else {
        console.error("Router instance is not available");
    }
};

// 页面置顶
export const scrollToTop = (scrollableDiv) => {
    scrollableDiv.scrollTo({
        top: 0,
        behavior: "auto",
    });
};

// 处理 \"
export const parseQualityDesc = (desc) => {
    try {
        const quality = JSON.parse(desc);
        let result = [];
        for (let key in quality) {
            result.push(`■ ${key}: ${quality[key]}`);
        }
        return result;
    } catch (e) {
        return [desc];
    }
};

// 解析瑕疵图
// export const extractImageUrls = (rawDefectUrl) => {


//     // JSON 解析失败时返回空数组
//     if (!rawDefectUrl || typeof rawDefectUrl !== "string" || rawDefectUrl.trim() === "") return [];
//     try {
//         // 解析 JSON 字符串
//         const parsedData = JSON.parse(rawDefectUrl);
//         // 使用 flatMap 处理每个值，分割字符串并展开结果
//         return Object.values(parsedData).flatMap((value) =>
//             value
//                 .split(/[\|，,]+/)
//                 .map((url) => url.trim())
//                 .filter(Boolean)
//         );
//     } catch (error) {
//         return [];
//     }
// };

// export const extractImageUrls = (rawDefectUrl) => {


//     // JSON 解析失败时返回空数组
//     if (!rawDefectUrl || typeof rawDefectUrl !== "string" || rawDefectUrl.trim() === "") return [];
//     try {
//         // 解析 JSON 字符串
//         const parsedData = JSON.parse(rawDefectUrl);



//         // 使用 flatMap 处理每个值，分割字符串并展开结果
//         return Object.values(parsedData).map(value => value.trim())

//     } catch (error) {
//         return [];
//     }
// };
export const extractImageUrls = (rawDefectUrl) => {


    // JSON 解析失败时返回空数组
    if (!rawDefectUrl || typeof rawDefectUrl !== "string" || rawDefectUrl.trim() === "") return [];
    try {
        // 解析 JSON 字符串
        const parsedData = JSON.parse(rawDefectUrl);


        // 过滤掉值为空的属性，并去除空格
        const filteredValues = Object.values(parsedData)
            .filter(value => value.trim() !== '')  // 过滤掉空的值
            .map(value => value.trim())  // 去除空格
            .flatMap(value => value.includes('|') ? value.split('|') : [value]);  // 如果包含 '|' 则分割，否者保持原值


        // 返回过滤后的值
        return filteredValues;
        // 使用 flatMap 处理每个值，分割字符串并展开结果
        // return Object.values(parsedData).map(value => value.trim())

    } catch (error) {
        return [];
    }
};

// 时间格式化
export const zeroPadding = (num, digit) => {
    let zero = "";
    for (let i = 0; i < digit; i++) {
        zero += "0";
    }
    return (zero + num).slice(-digit);
};

//批次函数
export const nowpatch = () => {
    let date = new Date();
    const formattedDate = zeroPadding(date.getFullYear(), 4) + zeroPadding(date.getMonth() + 1, 2) + zeroPadding(date.getDate(), 2);
    // 判断当前时间是否在 8:00 之前且分钟小于 50
    if (date.getMinutes() < 50 && date.getHours() <= 8) {
        // 返回前一天的批次
        date.setDate(date.getDate() - 1); // 设置为前一天
        return zeroPadding(date.getFullYear(), 4) + zeroPadding(date.getMonth() + 1, 2) + zeroPadding(date.getDate(), 2) + "_2";
    } else {
        // 返回当前日期的批次
        return formattedDate + "_2";
    }
};

// 今日批次函数,不考虑时间
export const todaypatch = () => {
    let date = new Date();
    const formattedDate = zeroPadding(date.getFullYear(), 4) + zeroPadding(date.getMonth() + 1, 2) + zeroPadding(date.getDate(), 2);
    // 返回当前日期的批次
    return formattedDate + "_1";
};


// 显示平台logo
export const patformimaglogo = (_platformname) => {
    if (_platformname === "采货侠") {
        return require("@/assets/images/chx.png");
    } else if (_platformname === "回收宝") {
        return require("@/assets/images/hsb.jpg");
    } else if (_platformname === "小当竞拍") {
        return require("@/assets/images/xd.png");
    } else if (_platformname === "拍机堂") {
        return require("@/assets/images/pjt.png");
    }
};

export const parseDoubleVerticalImageUrls = (rawDefectUrl) => {
    try {
        // 首先按 || 分割字符串，得到多个子字符串
        let groups = rawDefectUrl.split("||");

        // 对每一组，按 | 分割，再去除空白字符串，并过滤掉空数组
        let result = groups
            .map((group) => group.split("|").filter(Boolean)) // filter(Boolean) 用来去除空白值
            .filter((group) => group.length > 0); // 过滤掉空数组


        return result;
    } catch (error) {
        console.error("解析错误:", error);
        return [];
    }
}